// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import ArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import ArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import classNames from 'classnames'
import get from 'lodash/get'
import moment from 'moment'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import DateField from '../dateField/DateField'
import css from './dateNav.css'
type Props = {
  dateFormat: string
  basePath: string
  className?: string
  history: any
  match: any
}

class DateNav extends React.Component<Props> {
  static defaultProps = {
    dateFormat: 'YYYY-MM-DD',
  }
  getDate = () => {
    const { match, dateFormat } = this.props
    const date = get(match, 'params.date')

    // Default to current week, if params didn't have a week or it's in an invalid format.
    if (!date || !moment(date).isValid()) {
      return moment().format(dateFormat)
    }

    return date
  }
  onDateChange = (date) => {
    const { history, basePath } = this.props
    history.push(`${basePath}/${date}`)
  }
  getNextLink = () => {
    const { basePath, dateFormat } = this.props
    return `${basePath}/${moment(this.getDate()).add(1, 'day').format(dateFormat)}`
  }
  getPrevLink = () => {
    const { basePath, dateFormat } = this.props
    return `${basePath}/${moment(this.getDate()).add(-1, 'day').format(dateFormat)}`
  }

  render() {
    const { className } = this.props
    return (
      <div className={classNames(css.component, className)}>
        <Link className={classNames(css.navLink, css.navLinkPrev)} to={this.getPrevLink()}>
          <ArrowLeftIcon />
        </Link>
        <DateField value={this.getDate()} onChange={this.onDateChange} />
        <Link className={classNames(css.navLink, css.navLinkNext)} to={this.getNextLink()}>
          <ArrowRightIcon />
        </Link>
      </div>
    )
  }
}

export default withRouter(DateNav)
